/**
 * Authentication API.
 *
 * Thin wrappers over the gateway's /auth routes. Token storage is the client's
 * job (see lib/tokenStore.js); these functions only speak HTTP.
 */
import { api } from '../lib/apiClient.js';

/**
 * Sign in.
 *
 * May resolve with `requiresPasswordChange: true` and an access token that is
 * scoped to the password-change endpoints only. That is a success, not an
 * error — see AuthContext.signIn.
 *
 * There is no `register`: accounts are created by a platform administrator
 * (an organization owner) or by an owner adding a member.
 */
export const login = (credentials) => api.post('/auth/login', credentials, { skipTenant: true });
export const logout = (refreshToken) => api.post('/auth/logout', { refreshToken }, { skipTenant: true });
export const me = () => api.get('/auth/me', { skipTenant: true });
export const sessions = () => api.get('/auth/sessions', { skipTenant: true });
/** The signed-in person's own language and timezone; null = follow the organization. */
export const preferences = () => api.get('/auth/me/preferences', { skipTenant: true });
export const updatePreferences = (payload) => api.patch('/auth/me/preferences', payload, { skipTenant: true });
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email }, { skipTenant: true });
export const resetPassword = (payload) => api.post('/auth/reset-password', payload, { skipTenant: true });
export const changePassword = (payload) => api.post('/auth/change-password', payload, { skipTenant: true });
